import { LumooSpinner } from '@/components/lumoo-spinner'

export function PageSpinner({ message }: { message?: string } = {}) {
  return (
    <div className='fixed inset-0 flex items-center justify-center'>
      <div className='relative'>
        <LumooSpinner size={100} />
        {message && (
          <p className='text-muted-foreground absolute top-full left-1/2 mt-6 -translate-x-1/2 text-sm whitespace-nowrap'>
            {message}
          </p>
        )}
      </div>
    </div>
  )
}
